/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import log from 'loglevel';

const logger = log.getLogger('VENUS-Auth');
logger.setDefaultLevel(0);

const namespace = '[VENUS-Auth]';

export default class {
    static log(...message) {
        logger.log(namespace, ...message);
    }

    static info(...message) {
        logger.info(namespace, ...message);
    }

    static warn(...message) {
        logger.warn(namespace, ...message);
    }

    static error(...message) {
        logger.error(namespace, ...message);
    }

    static trace(...message) {
        logger.trace(namespace, ...message);
    }

    static debug(...message) {
        if (process.env.VUE_APP_TESTING) logger.debug(`${namespace}[DEBUG]`, ...message);
    }
}
